import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { register, unregister } from "./registerServiceWorker";
import configureStore from "./store/store";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { lectraMuiTheme } from "@lectra/mui-library";
import { AuthenticationProvider } from "@lectra/react-authentication";

/*
npm i react-router-dom
npm i react-router-dom@next
npm install react-router-dom --save
*/

const syncHistoryWithStore = (store, history) => {
  const { router } = store.getState();
  if (router && router.location) {
    history.replace(router.location);
  }
};

const createStore = ({ initialState = {}, history }) => {
  const store = configureStore(initialState, history);
  syncHistoryWithStore(store, history);
  store.history = history;
  return store;
};

const store = createStore({ history: createBrowserHistory() });
const { router } = store.getState();
const location = router.location;
const ApplicationContainer = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/healthcheck" element={<h2>OK</h2>}></Route>
        <Route
          path="*"
          element={
            <ThemeProvider theme={lectraMuiTheme}>
              {/* <AuthenticationProvider
                auth0={{
                  domain:
                    window.process !== undefined
                      ? window.process.env.REACT_APP_AUTH0_DOMAIN
                      : process.env.REACT_APP_AUTH0_DOMAIN,
                  audience:
                    window.process !== undefined
                      ? window.process.env.REACT_APP_AUTH0_AUDIENCE
                      : process.env.REACT_APP_AUTH0_AUDIENCE,
                  clientId:
                    window.process !== undefined
                      ? window.process.env.REACT_APP_AGENTCLIENTID
                      : process.env.REACT_APP_AGENTCLIENTID,
                  redirectUri: `${window.location.origin}/authenticated?sourceURL=${btoa(
                    location.pathname + location.search + location.hash
                  )}`,
                }}
                permission={["PCONV", "PATTERN_EXP"]}
                redirectTo403IfForbidden
                
              >
                <App />
              </AuthenticationProvider>*/}
              <App />
            </ThemeProvider>
          }
        ></Route>
      </Routes>
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(<ApplicationContainer />, document.getElementById("root"));

//register();
//unregister();
